/**
 * Route: Recipe Page with Container + View Pattern
 * 
 * This is a route-level component that delegates to the centralized 
 * Container + View pattern for clean separation of concerns
 */
import RecipePageContainer from './RecipePage.container';
// AppFrame removed: route-level wrapper provides layout

export function RecipePage() {
  return (
      <RecipePageContainer />
  );
}
